function LoggerList() {
    /// <summary>
    /// This object does the complete handling of the Widget.Master.Loggerlist.vb. <br/>
    /// It allows to add/delete favorites, to switch between logger, set a new start logger and filter the logger list.<br/>
    /// <br/>
    /// It is inherited from scripts/visualcore/widgets/Master/Master.js
    /// Author: ARF<br />
    /// Date: 20.8.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 30.9.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
LoggerList.prototype = new Master();

LoggerList.prototype.init = function () {
    /// <summary>
    /// First, this function loads existing user options and sets them. <br/>
    /// Then, it inits all click and filter handlers. 
    /// </summary>
    var me = this;
    try {
        
        if (me.error) { return false; }
        me.filterFav = false;


        me.userOptions = new vcUserOptions();
        me.initUserOptions();
        //set the current logger.
        me.setSelected(me.blid);
       
       // me.visual.find("#txtFilter").focus();
        //init the click handler for switching to another logger
        me.visual.find('.list').off('click', '.logger-box').on('click', '.logger-box', function () {
            me.setLogger(parseInt($(this).attr("data-blid"), 10));
        });
        ////init the click handler to set the start logger
        //me.visual.find('.menu #divBtnStartProject').button();
        //me.visual.find('.menu').off('click', '#divBtnStartProject').on('click', '#divBtnStartProject', function () {
        //    me.setStartProject();
        //});
        //init the filter events                                                                    
        me.visual.find("#txtFilter,#txtFilterExclude").off('keyup').on('keyup', function (e) {
            me.filter(); e.stopPropagation();
        });
        me.visual.find("#txtFilter,#txtFilterExclude").off('change').on('change', function (e) {
            me.filter(); e.stopPropagation();
        });

        me.visual.find("#div-admin-search").off('click').on('click', function (e) {
            me.visual.find(".menu").hide();
            me.visual.find(".list").height($(".LoggerList").height());


        me.visual.find(".list").AdminSearch({ invokeType: "addVisualBase" });
            e.stopPropagation();
        }).button();

        return true;
    } catch (ex) { me.writeError('initClickHandler', ex); return false;}
};



LoggerList.prototype.filter = function () {
    /// <summary>
    /// This function adds/removes two css-classes ('found' and 'exclude') for filtering loggers.<br/>
    /// When a logger with a filter expression gets found the 'found' class gets added - and the other way round for the 'exclude' class. <br/>
    /// At the end, basically all 'found' classes get shown and all 'exclude' classes get hidden - the favorites state gets considered as well.<br/>
    /// </summary>
    var me = this;
    var filter;
    var filterExclude;
    var i;
    try {

        //get a list of filter expressions
        if (me.visual.find("#txtFilter").val().trim().length > 0) {
            filter = me.visual.find("#txtFilter").val().trim();
            filter = filter.split(" ");
        } else {
            filter = [];
        }

        // get a list of exclude expressions
        if (me.visual.find("#txtFilterExclude").val().trim().length > 0) {
            filterExclude = me.visual.find("#txtFilterExclude").val().trim();
            filterExclude = filterExclude.split(" ");
        } else {
            filterExclude = [];
        }
        if (filter.length > 0) {
            //first, remove the 'found' class of all loggers
            me.visual.find(".logger-box").removeClass('found');
            // Then add it to the loggers which contain a filter expression
            for (i = 0; i < filter.length; i++) {
                if (filter[i].length>0) {
                me.visual.find(".logger-box:contains('" + filter[i] + "')").addClass('found');
                }
            }
        } else {
            // If no filter was set - set all loggers as found.
            me.visual.find(".logger-box").not(".found").addClass('found');
        }
        // ... same for the 'exclude' class
        if (filterExclude.length > 0) {
            me.visual.find(".logger-box").removeClass('exclude');
            for (i = 0; i < filterExclude.length; i++) {
                if (filterExclude[i].length > 0) {

                    me.visual.find(".logger-box:contains('" + filterExclude[i]  + "')").addClass('exclude');
                }
            }
        } else {
            me.visual.find(".logger-box.exclude").removeClass('exclude');
        }

        me.visual.find(".logger-box").not(".found").hide();
        me.visual.find(".logger-box.exclude").hide();

        if (me.filterFav) {
            // now, handle the favorites
            me.visual.find(".logger-box.found.likeIt").not(".exclude").show();
            me.visual.find(".logger-box.found").not(".likeIt").hide();
            if (me.visual.find(".logger-box:visible").length === 0) {
                me.showInfo(me.resources.noLoggersAreFavorites, "", false);
            } else {
                me.showInfo("", "", false);
            }

        } else {
            me.visual.find(".logger-box.found").not(".exclude").show();
            me.showInfo("", false);
        }


        return true;
    } catch (ex) { me.writeError('filter', ex); return false; }
};






LoggerList.prototype.initUserOptions = function () {
    /// <summary>
    /// This function fetches existing user options and sets the favorite icons.
    /// </summary>
    var me = this;
    var i;
    try {
       //first, load all set favorite loggers
        me.userOptions.getUserOptions({ 'optgroupid': 'logger-list-favorites' }, function (result) {
            if (result !== null) {
                if (result.rows === null) { me.showMessage(me.resources.errorOnLoad,true); return false; }
                for (i = 0; i < result.rows.length; i++) {
                    if (result.rows[i].bval) {
                        me.visual.find(".logger-box[data-blid=" + result.rows[i].optid + "]").addClass('likeIt');
                    }
                }
            }
            //now, we load all other filter options
            me.userOptions.getUserOptions({ 'optgroupid': 'logger-list' }, function (result) {
                if (result !== null) {
                    if (result.rows === null) { me.showMessage(me.resources.errorOnLoad,true); return false; }
                    for (i = 0; i < result.rows.length; i++) {
                        if (result.rows[i].optid === 1 && result.rows[i].bval) {
                            me.visual.find("#divBtnFilterFav").addClass("button-toggle-active");
                            me.filterFav = result.rows[i].bval;
                        }
                    }
                }
                me.initList();
                me.filter();
                return true;
            });
            return true;
        });
        return true;
    } catch (ex) { writeError('LoggerList.js.initUserOptions', ex);return false; }

}


LoggerList.prototype.initList = function () {
    /// <summary>
    /// This function inits all click handlers for the logger list items, the favorite icons and the favorites button.<br/>
    /// It get's initiated after all user options where set!
    /// </summary>
    var me = this;
    try {

        if (me.error) { return false; }
        me.visual.find(".list").fadeIn(500);
        me.visual.find('.list').off('click', '.logger-box').on('click', '.logger-box', function () {
            me.setLogger(parseInt($(this).attr("data-blid"), 10));
        });

        me.visual.find('.list').off('click', '.logger-box-fav').on('click', '.logger-box-fav', function (e) {
            me.toggleFavorites($(this), "logger-list-favorites"); e.stopPropagation();
        });
        
        me.visual.find('.menu').off('click', '#divBtnFilterFav').on('click', '#divBtnFilterFav', function () {
            me.toggleBtnFilterFav($(this), "logger-list");
        });

        
        me.visual.find("#txtFilter").focus();

        me.adoptListHeight();
       
        return true;
    } catch (ex) { me.writeError('initList', ex); return false; }
};



LoggerList.prototype.setLogger = function (blid) {
    /// <summary>
    /// Sends an ajax-request for switching to the selected logger.<br/>
    /// After everything was set the page gets reloaded.
    /// </summary>
    var me = this;
    var sIcon;
    try {

        if (me.error) { return false; }
        sIcon = me.visual.find(".logger-box[data-blid=" + blid + "] .logger-box-pic").html();
        me.visual.find('.list').off('click', '.logger-box');
        me.visual.find(".logger-box[data-blid=" + blid + "] .logger-box-fav").html("<img src='../../images/visualcore/loading.gif' style='height:100%;width:100%' />");
        window.VisualCoreService.setLogger(blid, window.location.href,
       
         function (result) {
             if (result === null) { alert("Err_setProject!");  me.showMessage(me.resources.err_saveData, true); return false; }
             if (result === false) {
                 if (me.mid === -1) {
                     window.location.reload();
                 } else {
                     me.showInfo(me.resources.noMenuRights, me.resources.pleaseSwitchMenu, true);
                     me.visual.find(".logger-box[data-blid=" + blid + "] .logger-box-pic").html(sIcon);
                     me.visual.find('.list')
                         .off('click', '.logger-box')
                         .on('click',
                             '.logger-box',
                             function() {
                                 me.setLogger(parseInt($(this).attr("data-blid"), 10));
                             });
                 }
                 return false;
             }
             me.setSelected(blid);
             // reload the page
             location.reload();
             return true;
         });
        return true;
    } catch (ex) { me.writeError('setLogger', ex); return false; }
};

LoggerList.prototype.setSelected = function (blid) {
    /// <summary>
    /// Simple function which sets the styles for the current logger<br/>
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }
        me.visual.find(".logger-box").removeClass("selected");
        me.visual.find(".logger-box[data-blid=" + blid + "]").addClass("selected");
        return true;
    } catch (ex) { me.writeError('setLogger', ex); return false; }
};


LoggerList.prototype.toggleFavorites = function (obj) {
    /// <summary>
    /// This function adds/removes a logger from the favorites list. It stores the setting as user option. 
    /// </summary>
    var me = this;
    try {
        obj.parents(".logger-box").toggleClass("likeIt");
        me.userOptions.setUserOptions({ 'optgroupid': 'logger-list-favorites', 'optid': parseInt(obj.parents(".logger-box").attr("data-blid"), 10), 'bval': obj.parents(".logger-box").hasClass("likeIt") }, function () { });
        me.filter();
        return true;
    } catch (ex) { me.writeError('toggleFavorites', ex); return false; }
};
